import React from "react";
import { useNavigate } from "react-router-dom";
import { FaUserShield, FaUserTag, FaUserPlus, FaRegStar } from "react-icons/fa";
import Layout from "../Component/Layout";

const tiles = [

  {
    key: "create-user",
    name: "Create User",
    icon: FaUserPlus,
    path: "/cable/user/create-user"
  },
  {
    key: "create-role",
    name: "Create Role",
    icon: FaUserShield,
    path: "/cable/user/create-role"
  }
 
  
];

const UserManagementHome = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div style={styles.pageTitle}>User Management</div>
      <div style={styles.pageSubtitle}>Manage roles and user access permissions.</div>

      <div style={styles.grid}>
        {tiles.map((tile) => {
          const Icon = tile.icon;
          return (
            <div
              key={tile.key}
              onClick={() => navigate(tile.path)}
              style={styles.card}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.08)";
                e.currentTarget.style.borderColor = "#dbe3ee";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.borderColor = "#e5e9f0";
              }}
            >
              <div style={styles.cardTopRow}>
                <div style={styles.iconBox}>
                  <Icon size={20} style={{ color: "#2563eb" }} />
                </div>
                <button
                  type="button"
                  onClick={(e) => e.stopPropagation()}
                  style={styles.starBtn}
                  aria-label="Favourite"
                >
                  <FaRegStar size={15} style={{ color: "#cbd5e1" }} />
                </button>
              </div>

              <div style={styles.cardTitle}>{tile.name}</div>
              <div style={styles.cardLink}>
                Open Module <span style={{ marginLeft: 4 }}>&rarr;</span>
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
};

const styles = {
  pageTitle: {
    fontSize: 26,
    fontWeight: 700,
    color: "#1e293b",
    marginBottom: 4
  },
  pageSubtitle: {
    fontSize: 14,
    color: "#64748b",
    marginBottom: 24
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: "20px"
  },
  card: {
    background: "#fff",
    borderRadius: 10,
    border: "1px solid #e5e9f0",
    padding: "18px 20px",
    cursor: "pointer",
    transition: "box-shadow 0.15s ease, border-color 0.15s ease",
    boxShadow: "none"
  },
  cardTopRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 14
  },
  iconBox: {
    width: 44,
    height: 44,
    borderRadius: 10,
    background: "#e8f0fe",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  starBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 4,
    lineHeight: 0
  },
  cardTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1e293b",
    marginBottom: 6
  },
  cardLink: {
    fontSize: 13,
    color: "#5b7a9d",
    display: "flex",
    alignItems: "center"
  }
};

export default UserManagementHome;